export const NO_CAPABILITIES_TOOLTIP =
    'You do not have permission to take this action, please contact an administrator.';
